import apiRequest from 'api/apiRequest';
import endpoints from 'api/endpoints';
import { AppDispatch } from 'store';
import {
  setPublicAssetProductDataAction,
  setLoadingProductsAction,
  setSelectedAbstractProductNameAction,
} from '../slice';
import { PublicAssetAbstractProductData, PRODUCT_SLUGS } from '../types';
import fetchAbstractProductOperation from './fetchAbstractProductOperation';

export const isNewPublicAsset = () => false;

const fetchPublicAssetProductTypesOperation =
  (source: string, imageId: string, slug?: string, preselectSlug?: string) => async (dispatch: AppDispatch) => {
    const endpoint = slug
      ? `${endpoints.publicAssetV1ProductPage}/${encodeURIComponent(slug)}`
      : `${endpoints.publicAssetV1ProductPage}/${source}/${imageId}`;

    dispatch(setLoadingProductsAction(true));
    const publicAssetProductData = await apiRequest<PublicAssetAbstractProductData>(endpoint, {}, 'GET', 'data');

    // Remove wallpaper product from list
    publicAssetProductData.products = publicAssetProductData.products.filter(
      (product) => product.slug !== PRODUCT_SLUGS.wallpaper,
    );
    dispatch(setPublicAssetProductDataAction(publicAssetProductData));
    // Setting selected abstract product as poster
    const productToSelect = publicAssetProductData.products.find(
      (product) => product.slug === (preselectSlug || PRODUCT_SLUGS.poster),
    );

    if (productToSelect) {
      dispatch(setSelectedAbstractProductNameAction(productToSelect.name));
      await dispatch(fetchAbstractProductOperation(productToSelect.productId, productToSelect.slug));
    } else if (publicAssetProductData.products.length) {
      dispatch(setSelectedAbstractProductNameAction(publicAssetProductData.products[0].name));
      await dispatch(
        fetchAbstractProductOperation(
          publicAssetProductData.products[0].productId,
          publicAssetProductData.products[0].slug,
        ),
      );
    }
    dispatch(setLoadingProductsAction(false));
  };

export default fetchPublicAssetProductTypesOperation;
